import script from "./footerAir.vue?vue&type=script&setup=true&lang=js"
export * from "./footerAir.vue?vue&type=script&setup=true&lang=js"

import "./footerAir.vue?vue&type=style&index=0&id=6cfc902a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cfc902a"]])

export default __exports__